<template>
  <nav class="navbar is-fixed-bottom" role="navigation" aria-label="main navigation">

    <div class="navbar-brand">
      <a class="navbar-item pd-logo" href="https://www.prestatiedatabank.nl">
        <img src="../../assets/pd_logo_light.png" height="50">
      </a>

      <!-- <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a> -->
    </div>

    <div class="navbar-end" >
      <div class="navbar-item survey-available" v-if="startdate && expirationdate">
        <p>Enquête toegankelijk vanaf {{ startdate }} tot {{ expirationdate }}</p>
      </div>

      <div class="navbar-item survey-available" v-if="!expirationdate && startdate">
        <p>Enquête toegankelijk vanaf {{ surveyInfo.startdate }}</p>
      </div>

      <div class="navbar-item survey-available" v-if="!startdate && expirationdate">
        <p>Enquête toegankelijk tot {{ surveyInfo.expirationdate }}</p>
      </div>

      <div class="navbar-item survey-available" v-if="!startdate && !expirationdate">
        <p>Enquête heeft geen vervaldatum.</p>
      </div>

    </div>

    <!-- <div id="navbarBasicExample" class="navbar-menu">

      <div class="navbar-end">
        <router-link to="/home" class="navbar-item" v-for="routes in links"
        v-bind:key="routes.id"
        :to="`${routes.page}`">{{routes.text}}</router-link>

        <div class="navbar-item">
          <div class="buttons">
            <router-link to="/home" class="button is-small has-text-grey is-white">
              Tussentijds stoppen?
            </router-link>
          </div>
        </div>
      </div>

    </div> -->

  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      surveyInfo: this.$store.getters.getInfo || null,
      // startdate: this.$store.getters.getInfo.startdate || null,
      // expirationdate: this.$store.getters.getInfo.expirationdate || null,
      links: [
        // {
        //   id: 0,
        //   text: 'Home',
        //   page:'/home'
        // },
        // {
        //   id: 1,
        //   text: 'Formulier',
        //   page:'/form'
        // }
      ]
    }
  },
  computed: {
    startdate: function () {
      if (this.surveyInfo.startdate && this.surveyInfo.startdate !== undefined && this.surveyInfo.startdate !== 'undefined') {
        return this.surveyInfo.startdate
      } else {
        return null
      }
    },
    expirationdate: function () {
      if (this.surveyInfo.expirationdate && this.surveyInfo.expirationdate !== undefined && this.surveyInfo.expirationdate !== 'undefined') {
        return this.surveyInfo.expirationdate
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>
.pd-logo {
  left: 8px;
}

.navbar {
  background-color: transparent;
  z-index: -1 !important;
}

.survey-available {
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue